import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { VideoData } from '@core/models/entities/video.models';
import { IconComponent } from '@shared/components/icon/icon.component';

@Component({
  selector: 'gus-video-card',
  standalone: true,
  imports: [CommonModule, IconComponent],
  templateUrl: './video-card.component.html',
  styleUrl: './video-card.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VideoCardComponent implements OnInit {
  @Input() item!: VideoData;

  imageLoaded = false;

  get img(): string | null {
    return this.item.picture.location ?? null;
  }

  constructor(private cdr: ChangeDetectorRef) {}
  ngOnInit(): void {
    const img = new Image();
    img.src = this.img!;
    img.onload = () => {
      this.imageLoaded = true;
      this.cdr.detectChanges();
    };
  }
}
